import { useEffect } from "react";

const ICONS = {
  info: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
  success: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/>
    </svg>
  ),
  warning: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  danger: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
    </svg>
  ),
};

function Toast({
  show,
  onClose,
  setShow,
  title,
  message,
  variant = "info",
  position = "top-right",
  autoClose = 4000,
  actions = [],
}) {
  const close = onClose ?? (() => setShow?.(false));

  useEffect(() => {
    if (!show || autoClose === 0) return;
    const t = setTimeout(close, autoClose);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, autoClose]);

  if (!show) return null;

  return (
    <div className={`tc-toast tc-toast--${variant} tc-toast--${position}`} role="alert">
      <div className="tc-toast-body">
        <span className="tc-toast-icon">{ICONS[variant]}</span>
        <div className="tc-toast-text">
          {title && <div className="tc-toast-title">{title}</div>}
          {message && <div className="tc-toast-msg">{message}</div>}
        </div>
        <button className="tc-toast-close" onClick={close} aria-label="Close">×</button>
      </div>
      {actions.length > 0 && (
        <div className="tc-toast-actions">
          {actions.map((a, i) => (
            <button
              key={i}
              className={`tc-toast-action tc-toast-action--${a.variant || "ghost"}`}
              onClick={a.onClick}
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Toast;
